<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="companyName">
        <el-input v-model="queryParams.companyName" filterable placeholder="公司名称" @keyup.enter.native="search" clearable> </el-input>
      </el-form-item>
      <el-form-item  prop="consignee">
        <el-input v-model="queryParams.consignee" placeholder="收货人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="receivingPhone">
        <el-input v-model="queryParams.receivingPhone" placeholder="联系号码" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="shipmentNo">
        <el-input v-model="queryParams.shipmentNo" placeholder="申请单编码" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="salesMan">
        <el-input v-model="queryParams.salesMan" placeholder="业务员" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="whetherToPay">
        <el-select v-model="queryParams.whetherToPay" filterable placeholder="是否付款" @change="search" clearable>
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="logisticsStatus">
        <el-select v-model="queryParams.logisticsStatus" filterable placeholder="发货状态" @change="search" clearable>
          <el-option label="未发货" value="0"></el-option>
          <el-option label="已发货" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable placeholder="审核状态" @change="search" clearable>
          <el-option label="待提交" value="0"></el-option>
          <el-option label="审核中" value="1"></el-option>
          <el-option label="审核通过" value="2"></el-option>
          <el-option label="审核驳回" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="申请开始日期"
                end-placeholder="申请结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="adds" v-hasPermi="['shipment:request:add']">新增</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" ref="tableData" border v-loading="loading" @sort-change="tableSortChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="5">
                <el-form-item label="申请单编码：" >
                  <span>{{ props.row.shipmentNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="收货人：" >
                  <span>{{ props.row.consignee }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收货地址：" >
                  <span>{{ props.row.shippingAddress }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="收货电话：" >
                  <span>{{ props.row.receivingPhone }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="创建人：" >
                  <span>{{ props.row.createUsername }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="createTime" label="申请时间" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="salesMan" label="业务员" min-width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cancelFlag" label="是否作废" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.cancelFlag == '0'" type="success">否</el-tag>
          <el-tag v-else type="danger">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="whetherToPay" label="是否付款" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.whetherToPay == '1'" type="success">是</el-tag>
          <el-tag v-else type="warning">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="toPayDate" label="付款时间" align="center" min-width="100">
          <template slot-scope="scope">
              <span>{{ parseTime(scope.row.toPayDate,'{y}-{m}-{d}') }}</span>
          </template>
      </el-table-column>
      <el-table-column prop="izDocument" label="是否制单" align="center" min-width="100">
          <template slot-scope="{row}">
              <el-tag type="warning" v-if="row.izDocument == '0'">未制单</el-tag>
              <el-tag type="success" v-if="row.izDocument == '1'">已制单</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="modeOfTransport" label="运输方式" align="center" min-width="100">
        <template slot-scope="{row}">
          <el-tag v-if="row.modeOfTransport == '0'">自提</el-tag>
          <el-tag v-if="row.modeOfTransport == '1'">送货</el-tag>
          <el-tag v-if="row.modeOfTransport == '2'">快递寄付</el-tag>
          <el-tag v-if="row.modeOfTransport == '3'">快递到付</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="logisticsStatus" label="物流状态" align="center" min-width="100">
          <template slot-scope="{row}">
              <el-tag type="danger" v-if="row.logisticsStatus == '0'">未发货</el-tag>
              <el-tag type="success" v-if="row.logisticsStatus == '1'">已发货</el-tag>
          </template>
      </el-table-column>

      <el-table-column label="物流信息" align="center" min-width="120" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span v-if="row.logisticsCompany">{{row.logisticsCompany}},</span>
          <span v-if="row.logisticsNo">{{row.logisticsNo}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="审核状态" align="center" min-width="100">
          <template slot="header">
              <el-tooltip content="审核中表示提交成功" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
              审核状态
          </template>
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == '0'">待提交</el-tag>
          <el-tag v-else-if="row.status == '1'">审核中</el-tag>
          <el-tag v-else-if="row.status == '2'" type="success">审核通过</el-tag>
          <el-tag v-else-if="row.status == '3'" type="danger">审核驳回</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="审核时间" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="backNoteShow" prop="backNote" label="备注" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="detailInfo(scope.row)">详情</el-button>
          <el-dropdown @command="(command) => handleCommand(command, scope.row)" v-if="hasDropdownItems(scope.row)">
              <span class="el-dropdown-link">
                <i class="el-icon-d-arrow-right el-icon--right"></i>更多
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-hasPermi="['shipment:request:flowView']"  command="viewProcess" v-if="scope.row.status != 0" icon='el-icon-view'>查看流程</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:request:update']"    command="editShipment" v-if="(scope.row.status == 0 || scope.row.status == 3) && scope.row.cancelFlag == 0" icon="el-icon-edit">编辑</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:request:del']"       command="delShipment" v-if="scope.row.cancelFlag == 1" icon="el-icon-delete">删除</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:request:verify']"    command="verifyShipment" v-if="scope.row.status ==1 && scope.row.cancelFlag == 0" icon="el-icon-s-check">审核</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:outEntrepot:update']" command="openMakeOutEntrepot" v-if="scope.row.status ==2 && scope.row.izDocument !='1' && scope.row.cancelFlag == 0" icon="el-icon-truck">制出库单</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:request:invalid']" v-if="scope.row.cancelFlag == 0" command="cancelShipment" icon="el-icon-s-release">作废</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['shipment:request:remark']" v-if="scope.row.cancelFlag == 0" command="remarkShipment" icon="el-icon-edit">修改备注</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
            v-show="total>0"
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="initData"
    />
    <!--删除提示框-->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span type="warning">确认删除？</span>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="removeShipment()">确 定</el-button>
                  </span>
    </el-dialog>
      <!--备注填写-->
      <el-dialog title="修改备注" :visible.sync="remarkFormVisible" width="30%">
          <el-form :model="remarkForm">
              <el-form-item label="备注：">
                  <el-input v-model="remarkForm.backNote" autocomplete="off"></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="remarkFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="editRemark()">确 定</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
  import { shipmentList, delShipment, invalidShipment, updateShipmentRequest } from "@/api/api.js";//查询发货申请列表
  import webSocketService from '@/utils/WebSocketService';
  import { mapGetters } from 'vuex'
  export default {
    name: 'shipmentRequest',
    data () {
      return {
        an: false,
        loading: false,
        dateRange: [],
        remarkFormVisible: false,
        remarkForm: {id: undefined, backNote: undefined},
        dialogVisible: false,
        removeId: null,
        formLabelWidth: '120px',
        queryParams: {
          companyName: undefined,
          consignee: undefined,
          receivingPhone: undefined,
          whetherToPay: undefined,
          shipmentNo: undefined,
          salesMan: undefined,
          logisticsStatus: undefined,
          status: undefined,
        },
        tableData: [{
          id: undefined,
          companyName: undefined,
          applyCause: undefined,
          useDevice: undefined,
          modeOfTransport: undefined,
          deliveryDate: undefined,
          shippingAddress: undefined,
          shipmentNo: undefined,
          consignee: undefined,
          receivingPhone: undefined,
          whetherToPay: undefined,
          payMode: undefined,
          createUsername: undefined,
          logisticsStatus: undefined,
          status: undefined,
          payVoucher: undefined,
          backNote: undefined,
          toPayDate: undefined
        }],
        searchTime: [],
        page: 1,
        pageSize: 20,
        total: 0,
        rules: {
          phone: [
            { required: true, message: "请输入联系方式", trigger: "blur" },
            {
              pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: "请输入正确的手机号码",
              trigger: "blur"
            }
          ],
        },
        agentOptions: [],
        // 排序方式
        sortOrder: "",
        // 排序名称
        sortName: "",
      }
    },
    computed: {
      ...mapGetters(['shipmentLastUpdated']),
      adminShow () {
        return this.$store.getters.user.userType == "1";
      },
      backNoteShow() {
        return this.checkPermi(['shipment:request:remark']);
      }
    },
    methods: {
      hasDropdownItems(row) {
        return (
          (this.checkPermi(['shipment:request:flowView']) && row.status != 0) ||
          (row.cancelFlag == 0 && this.checkPermi(['shipment:request:update']) && (row.status == 0 || row.status == 3)) ||
          (row.cancelFlag == 1 && this.checkPermi(['shipment:request:del'])) ||
          (row.cancelFlag == 0 && this.checkPermi(['shipment:request:verify']) && row.status == 1) ||
          (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:update']) && row.status ==2 && row.izDocument !='1') ||
          (row.cancelFlag == 0 && this.checkPermi(['shipment:request:invalid'])) ||
          (row.cancelFlag == 0 && this.checkPermi(['shipment:request:remark']))
        );
      },
      handleCommand(command, row) {
        switch (command) {
          case "viewProcess":
            this.flowDetail(row);
            break;
          case "editShipment":
            this.edit(row);
            break;
          case "delShipment":
            this.openRemove(row);
            break;
          case "verifyShipment":
            this.verifyShipment(row);
            break;
          case "openMakeOutEntrepot":
            this.openOutEntrepot(row);
            break;
          case "cancelShipment":
            this.openCancel(row);
            break;
          case "remarkShipment":
            this.openRemark(row);
            break;
          default:
            break;
        }
      },

      openCancel(row) {
              this.$confirm('此操作将作废单据?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  center: true,
              }).then(() => {
                  invalidShipment({id: row.id}).then((res) => {
                      if (res.data.code == 200) {
                          this.$message({
                              title: "成功",
                              message: "操作成功",
                              type: "success",
                              duration: 1500,
                          });
                          this.submitWebSocketMessage();
                          this.initData();
                      } else {
                          this.$message.error(res.data.message);
                      }
                  });
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: '已取消'
                  });
              });
      },
        openRemark(row) {
            this.remarkFormVisible = true;
            this.remarkForm.id = row.id;
            this.remarkForm.backNote = row.backNote;
        },
        editRemark() {
            updateShipmentRequest(this.remarkForm).then((res) => {
                if (res.data.code == 200) {
                    this.$notify({
                        title: "成功",
                        message: "修改成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.remarkFormVisible = false;
                    this.remarkForm = {};
                    this.initData();
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
      openRemove(row) {
        this.dialogVisible = true;
        this.removeId = row.id;
      },
      removeShipment() {
        delShipment({id: this.removeId}).then((res) => {
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 1500,
            });
            this.dialogVisible = false;
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      },
      verifyShipment(row) {
        this.$router.push({
          path: "/shipmentRequest/flowShipmentAct",
          query: {id: row.id, processId: row.flowId}
        });
      },
      openOutEntrepot(row) {
        this.$router.push({
          path: "/shipmentRequest/outEntrepotUpdate",
          query: { shipmentId: row.id }
        });
      },
      hidden () {
        this.an = this.an == false ? true : false;
      },
      // 搜索
      search () {
        this.tableData = [];
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.dateRange = [];
        this.resetForm("queryForm");
        this.search();
      },
      // 排序
      tableSortChange (val) {
        this.sortOrder = val.order == "descending" ? "desc" : "asc";
        this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
        this.initData();
      },
      // 获取列表的数据
      initData () {

        let params = {
          model: {
            ... this.addDateRange(this.queryParams, this.dateRange),
            order: this.sortOrder,
            sort: this.sortName,
          },
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        shipmentList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.tableData.map((item, index) => {
            item.ids = index + 1
          })
          this.total = res.data.data.total;
        })

      },
      // 新增发货申请
      adds () {
        this.$router.push({ path: '/shipmentRequest/shipmentRequestAdd' })
      },
      //修改发货申请
      edit (row) {
        this.$router.push({ path: '/shipmentRequest/shipmentRequestUpdate', query: {id: row.id}})
      },
      detailInfo(row) {
        this.$router.push({
          path: "/shipmentRequest/shipmentRequestDetail",
          query: {id: row.id, processId: row.flowId}
        });
      },
      flowDetail (row) {
        this.$router.push({
          path: "/shipmentRequest/shipmentFlowView",
          query: {id: row.id, processId: row.flowId}
        });
      },
      // 弹窗的取消
      cancelDialog () {
        this.dialog = false;
      },
      submitWebSocketMessage() {
          const message = {
              content: "submit",
              timestamp: Date.now(),
          };
          webSocketService.sendToTopic('/topic/shipment', message);
      },
    },
    mounted () {
      this.initData();
    },
    created () {},
      watch: {
          '$route': {
              handler: function (to, from) {
                  if (to.name == "shipmentRequest") {
                      this.initData();
                  }
              },
              // 深度观察监听
              deep: true,
          },
          shipmentLastUpdated(newVal, oldVal) {
            // 当 shipmentCount 变化时，重新加载列表数据
            this.initData();
          }
      },
      
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
